import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetLicenceProfileAsync,
  ILicenceProfileResponse,
} from "../../api/LicenceProfile";
import { RootState } from "../store";

export interface LicenceProfileState {
  fetchStatus: string;
  error: any;
  licenceProfileResponse?: ILicenceProfileResponse;
}

const initialState: LicenceProfileState = {
  error: undefined,
  fetchStatus: "Loading...",
  licenceProfileResponse: undefined,
};

export const loadLicenceProfileAsync = createAsyncThunk(
  "licenceProfile/load",
  async (profileNo: string) => {
    const response = await GetLicenceProfileAsync(profileNo);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const licenceProfileSlice = createSlice({
  name: "licenceProfile",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadLicenceProfileAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadLicenceProfileAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.licenceProfileResponse = action.payload;
      })
      .addCase(loadLicenceProfileAsync.rejected, (state, action) => {
        state.fetchStatus = "rejected";
        state.error = action.payload;
      });
  },
});

export const selectLicenceProfileResponse = (state: RootState) =>
  state.licenceProfileResponse;

export default licenceProfileSlice.reducer;
